import { AxiosInstance } from 'axios'

import { SolutionTypeTemplate } from '@dc-shared-web/hooks/api/solutionType'

export const fetchSolutionTypes = async (
  apiClient: AxiosInstance
): Promise<SolutionTypeTemplate[]> => {
  const {
    data: { data },
  } = await apiClient.get(`/api/solution-type-templates`)
  return data
}
